module.exports = __webpack_public_path__ + "static/media/abs-found.7f4698a4.png";